import { IconProps } from "interfaces/icons";
import calculateSideByRatio from "utils/calculateSideByRatio";

const SIDES_RATIO = 1;

const LogOutIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 30;

	if (size) {
		height = size;
	}
	const width = calculateSideByRatio(height, SIDES_RATIO);

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 30 30"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.97898 2.07129H14.1719C15.8473 2.07129 17.2169 3.45924 17.2169 5.13438V7.84141C17.2169 8.2609 16.8768 8.60083 16.4573 8.60083C16.0378 8.60083 15.6978 8.2609 15.6978 7.84141V5.13438C15.6957 4.28969 15.0166 3.60248 14.1719 3.59037H3.97898C3.14117 3.59037 2.48199 4.29681 2.48199 5.13438V24.775C2.47202 25.6076 3.13879 26.2905 3.97138 26.3003H14.1716C15.013 26.2972 15.6943 25.6161 15.6978 24.775V22.1245C15.6978 21.7048 16.0378 21.3649 16.4573 21.3649C16.8768 21.3649 17.2169 21.7048 17.2169 22.1245V24.775C17.2124 26.4549 15.8518 27.8153 14.1719 27.8193H3.97898C2.30692 27.8132 0.956264 26.4521 0.962915 24.7798V5.13438C0.962915 3.45924 2.3036 2.07129 3.97898 2.07129Z"
				fill={color}
			/>
			<path
				d="M26.4808 15.7431H8.5051C8.0856 15.7431 7.74545 15.403 7.74545 14.9835C7.74545 14.5642 8.0856 14.2241 8.5051 14.2241H26.6495L22.7526 9.71956C22.4778 9.40007 22.512 8.91881 22.8284 8.64112C23.1441 8.3651 23.6237 8.39717 23.8994 8.71262V8.7131L28.8113 14.3706C28.9923 14.5196 29.0942 14.7438 29.0876 14.9778C29.0805 15.2122 28.9655 15.4303 28.7757 15.5681L23.8633 20.4804C23.5666 20.7771 23.0856 20.7771 22.7894 20.4804C22.4965 20.193 22.492 19.7231 22.7792 19.4302C22.7825 19.4272 22.7858 19.4238 22.7894 19.4205L26.4808 15.7431Z"
				fill={color}
			/>
		</svg>
	);
};

export default LogOutIcon;
